<div class="error-page-wrap text-c">
  <div>
    <img alt="Page not found" class="konrad" src="https://storage.googleapis.com/static-imgs/console/konrad/page-not-found.png" />
  </div>
  <h1 class="font-roboto size-20px padding-b-20">404 - page not found</h1>
  <div class="margin-t-20 margin-b-20">
    <a href="/" class="btn-404 font-roboto">Click here to navigate back to the start page</a>
  </div>
</div>
